import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table Account table-striped-columns table-striped table-hover table-bordered table-row-dashed table-row-gray-300 align-middle gs-0 gy-2" }
const _hoisted_2 = { class: "gy-4" }
const _hoisted_3 = { class: "fw-bolder fs-6 text-gray-800 border-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, null, -1)
const _hoisted_5 = {
  rowspan: "2",
  class: "pb-8"
}
const _hoisted_6 = {
  rowspan: "2",
  class: "pb-8"
}
const _hoisted_7 = {
  colspan: "2",
  class: "text-center border"
}
const _hoisted_8 = {
  colspan: "2",
  class: "text-center border"
}
const _hoisted_9 = {
  colspan: "2",
  class: "text-center border"
}
const _hoisted_10 = {
  rowspan: "2",
  class: "pb-8"
}
const _hoisted_11 = { class: "fw-bolder fs-6 text-gray-800 text-center border-0" }
const _hoisted_12 = { class: "border" }
const _hoisted_13 = { class: "border" }
const _hoisted_14 = { class: "border" }
const _hoisted_15 = { class: "border" }
const _hoisted_16 = { class: "border" }
const _hoisted_17 = { class: "border" }
const _hoisted_18 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_19 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Item = _resolveComponent("Item")!
  const _component_l_money = _resolveComponent("l-money")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_page_container = _resolveComponent("page-container")!
  const _component_n_drawer = _resolveComponent("n-drawer")!

  return (_openBlock(), _createBlock(_component_n_drawer, {
    show: _ctx.open,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
    d: "",
    resizable: "",
    placement: "left",
    "default-width": 500
  }, {
    default: _withCtx(() => [
      _createVNode(_component_page_container, { loading: _ctx.loading }, {
        default: _withCtx(() => [
          _createVNode(_component_a_table, {
            label: _ctx.$t('Ledger'),
            info: `خلال الفترة من `
          }, {
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_1, [
                _createElementVNode("thead", _hoisted_2, [
                  _createElementVNode("tr", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("AllTransaction")), 1),
                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("StatementAccount")), 1),
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("Firstbalance")), 1),
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("Accountbalance")), 1),
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("Closingbalance")), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("approval")), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_11, [
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("Debit")), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("Creditor")), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("Debit")), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("Creditor")), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("Debit")), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("Creditor")), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.models.model, (i, index) => {
                    return (_openBlock(), _createBlock(_component_Item, {
                      model: i,
                      key: index
                    }, null, 8, ["model"]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", null, [
                  _createElementVNode("tr", _hoisted_18, [
                    _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$t("Total")), 1),
                    _hoisted_20,
                    _createElementVNode("td", null, [
                      _createVNode(_component_l_money, {
                        model: _ctx.models.creditor
                      }, null, 8, ["model"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_l_money, {
                        model: _ctx.models.debit
                      }, null, 8, ["model"])
                    ]),
                    _hoisted_21,
                    _hoisted_22
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["show"]))
}